module.exports = __webpack_public_path__ + "img/services-details.96e59182.jpg";